
import { onMounted } from "vue";
import useDevice from "@/compositions/device";

export default {
  setup() {
    const { openVideo } = useDevice();
    onMounted(async () => {
      await openVideo(true, false, "video#localVideo");
    });
  }
};
